var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMileage24 = function SvgMileage24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.062 20A9.905 9.905 0 0 1 3.017 9.577a9.967 9.967 0 0 1 3.659-4.05 10.038 10.038 0 0 1 10.528-.074 9.968 9.968 0 0 1 3.716 3.998 9.906 9.906 0 0 1 1.044 5.345c-.159 1.844-.942 3.72-2.052 5.204",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.593 11a.643.643 0 0 0-.42.162.546.546 0 0 0-.129.178.507.507 0 0 0-.044.21.52.52 0 0 0 .042.19c.262.621.774 1.979 1.275 3.269.25.647.498 1.274.706 1.794.157.405.343.8.558 1.18.54.854 1.67 1.294 2.588.828.914-.485 1.06-1.616.508-2.463a9.377 9.377 0 0 0-.833-1.032 92.634 92.634 0 0 0-1.338-1.464c-.971-1.045-2.002-2.131-2.472-2.645a.594.594 0 0 0-.209-.15.647.647 0 0 0-.26-.054L8.593 11Z",
    fill: "currentColor"
  })));
};
export default SvgMileage24;